import { useRef, useCallback } from 'react';

export const useVideoPreloader = () => {
  const videoCache = useRef({});

  const preloadVideo = useCallback(async (src) => {
    // Return cached video if available
    if (videoCache.current[src]) {
      return videoCache.current[src];
    }

    // Create and preload new video
    const video = document.createElement('video');
    video.muted = true;
    video.playsInline = true;
    video.preload = 'auto';

    const loadPromise = new Promise((resolve, reject) => {
      video.onloadeddata = () => resolve(video);
      video.onerror = () => reject(new Error(`Failed to load video: ${src}`));
    });

    video.src = src;
    video.load();

    try {
      const loadedVideo = await loadPromise;
      videoCache.current[src] = loadedVideo;
      return loadedVideo;
    } catch (error) {
      console.error('Video preload error:', error);
      throw error;
    }
  }, []);

  const clearCache = useCallback(() => {
    Object.values(videoCache.current).forEach(video => {
      video.src = '';
      video.load();
    });
    videoCache.current = {};
  }, []);

  return { preloadVideo, clearCache };
}; 